module.exports = __webpack_public_path__ + "img/kuaixun_bg_3.cdff0773.png";